import React, { Suspense, useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router';
import Templates from './Templates';
import EditTemplate from './EditTemplate';
import Accounts from './accounts/Accounts';
import AccountDetails from './accountDetails/AccountDetails';
import Campaigns from './campaigns/Campaigns';
import Content from './content/Content';
import EmailEditor from './content/EmailEditor';
import Notifications from './notifications/Notifications';
import Auditing from './auditing/Auditing';
import Imports from './imports/Imports';
import SuperAdminNavigation from './SuperAdminNavigation';
import Features from './features/Features';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import NpsScore from './nps/NpsScore';
import SplashScreen from '../splashScreen/SplashScreen';

const drawerWidth = 160;

const SuperAdmin = () => {
    const theme = useTheme();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const boxStyles = { marginLeft: isSmallScreen ? '0' : `${drawerWidth}px`, flexGrow: 1 };

    const toggleDrawer = (newOpen) => {
        setOpen(newOpen);
    };

    useEffect(() => {
        setOpen(false);
    }, [location]);

    const isExcludedRoute = location.pathname.includes('superadmin/templates/') || location.pathname.includes('superadmin/emails/');

    return (
        <Suspense fallback={<SplashScreen />}>
            <Box sx={boxStyles}>
                {!isExcludedRoute && (
                    <>
                        {!isSmallScreen && <SuperAdminNavigation width={drawerWidth} />}
                        {isSmallScreen && <SuperAdminNavigation width={drawerWidth} isSmallScreen={isSmallScreen} open={open} onClose={() => toggleDrawer(false)} />}
                    </>
                )}
            </Box>
            <Routes>
                <Route path="templates" element={(
                    <Box sx={boxStyles}>
                        <Templates showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="templates/:templateId" element={<EditTemplate />} />
                <Route path="campaigns" element={(
                    <Box sx={boxStyles}>
                        <Campaigns showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="accounts" element={(
                    <Box sx={boxStyles}>
                        <Accounts showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="accounts/:id" element={(
                    <Box sx={boxStyles}>
                        <AccountDetails showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="notifications" element={(
                    <Box sx={boxStyles}>
                        <Notifications showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="auditing" element={(
                    <Box sx={boxStyles}>
                        <Auditing showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="imports" element={(
                    <Box sx={boxStyles}>
                        <Imports showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="content" element={(
                    <Box sx={boxStyles}>
                        <Content showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="emails/:id" element={(
                    <Box>
                        <EmailEditor />
                    </Box>
                )} />
                <Route path="features" element={(
                    <Box sx={boxStyles}>
                        <Features showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="nps" element={(
                    <Box sx={boxStyles}>
                        <NpsScore showHamburger={isSmallScreen} onClickHamburger={toggleDrawer} />
                    </Box>
                )} />
                <Route path="/" element={<Navigate to="accounts" />} />
            </Routes>
        </Suspense>
    );
};

export default SuperAdmin;
